var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96861 4.70217V2.37717C9.96861 2.00217 9.51861 1.81884 9.26028 2.08551L6.09361 5.24384C5.92694 5.41051 5.92694 5.66884 6.09361 5.83551L9.25194 8.99384C9.51861 9.25217 9.96861 9.06884 9.96861 8.69384V6.36884C13.0769 6.36884 15.5353 9.21884 14.8519 12.4438C14.4603 14.3355 12.9269 15.8605 11.0436 16.2522C8.06861 16.8772 5.41861 14.8355 5.01861 12.0772C4.96028 11.6772 4.61028 11.3688 4.20194 11.3688C3.70194 11.3688 3.30194 11.8105 3.36861 12.3105C3.88528 15.9688 7.36861 18.6772 11.3103 17.9105C13.9103 17.4022 16.0019 15.3105 16.5103 12.7105C17.3353 8.43551 14.0853 4.70217 9.96861 4.70217Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.3bfe2b1bf04c4c6cc7d22bcb7c561b6e.svg";
export { ForwardRef as ReactComponent };